import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
import OutputsPage from "./OutputsPage";
var Outputs = function () {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(OutputsPage, null))); } })));
};
export default Outputs;
